import RenderWriting from "components/Practice/writing/RenderWriting";
import * as React from "react";
import useQuery from "hooks/useQuery";
import { useHistory } from "react-router-dom";
import { useAsync } from "react-async-hook";
import Spinner from "components/Spinner";
import { Typography } from "@material-ui/core";
import MainWrapper from "layout/MainWrapper";
import { fetchWritingTask } from "utilities/awsCRUD";
import useHomework from "hooks/useHomework";

interface WritingDetailViewProps {}

const WritingDetailView: React.FC<WritingDetailViewProps> = () => {
  const { onSubmit, submittedAnswers, title, time } = useHomework();
  const history = useHistory();
  let query = useQuery();
  const id = query.get("id");
  const typeName = query.get("typeName");
  React.useEffect(() => {
    if (!id || !typeName) {
      history.push("/practice");
    }
  }, [id, typeName, history]);
  const practice = useAsync(fetchWritingTask, [id, typeName]);
  return (
    <>
      {practice.loading && <Spinner />}
      {practice.error && (
        <MainWrapper>
          <Typography variant="h5" color="error">
            Error: {practice.error.message}
          </Typography>
        </MainWrapper>
      )}
      {practice.result && (
        <RenderWriting
          practice={[practice.result]}
          title={title ? `Writing ${title}` : "Writing Practice"}
          onSubmit={onSubmit}
          time={time}
          submittedAnswers={submittedAnswers?.text}
        />
      )}
    </>
  );
};

export default WritingDetailView;
